module.exports = __webpack_public_path__ + "img/bg24.cf932f36.jpeg";